<template>
  <div class="full-page-wrap">
    <div class="container">
      <h3 class="common-head text-center mt-12">
        WYSD (APAC) Youth Ambassadors
      </h3>
      <div class="about-desc">
          <div class="about-logo">
            <img src="../assets/Images/landing/WYSD 2022 Youth Ambassador Badge.png" />
          </div>
          <div class="about-text">
            <p>
              The WYSD (APAC) Youth Ambassadors Programme is curated for passionate youth leaders to share their views and aspirations pertaining to skills for the future with like-minded peers from the Asia-Pacific region.
            </p>
            <br />
            <p>The pioneering batch of the WYSD (APAC) Youth Ambassadors comprises 67 youths from China, India, Indonesia, Japan, Myanmar, Pakistan, Philippines, Singapore, South Korea, Thailand and Vietnam. These Youth Ambassadors will take charge in mobilising their peer network to organise ground-up initiatives in celebration of the WYSD (APAC) 2022.</p>
          </div>
        </div>
        <div class=" intro-sub-head mt-12 mb-5  text-center">
          <h3 class="common-head">
            Introduction to the Youth Ambassadors
          </h3>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F1-min.png?alt=media&token=39539970-08ad-4c7e-98b0-78a6453ee00d" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
           <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F2-min.png?alt=media&token=60beb45c-0378-4554-8e5d-bfe3edef859e" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F3-min.png?alt=media&token=491b99c9-129d-4ec0-af25-e78e058ebb99" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
           <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F4-min.png?alt=media&token=763c7a54-a940-4c6a-b91b-2fd1094a2fb9" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F5-min.png?alt=media&token=578ba4a1-8349-490a-9ab2-606cf9572b0a" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F6-min.png?alt=media&token=5acb34cc-c86c-4bf5-8041-e81ae83946b1" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F7-min.png?alt=media&token=ba56fa23-6747-4800-ad35-6bb97f211a57" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F8-min.png?alt=media&token=34f45032-06b3-43d1-8b9a-838bcddda25f" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
           <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F9-min.png?alt=media&token=2340734d-1ccb-4255-a86c-14d600b3bb19" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F10-min.png?alt=media&token=411826d9-cec7-488a-a54c-e3f113c18a16" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F11-min.png?alt=media&token=53cfad21-f630-414f-b0f7-87d991d62180" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F12-min.png?alt=media&token=01af99a9-be3d-4653-8954-8aa79326fca8" />
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F13-min.png?alt=media&token=2b0c4949-ff48-4fcd-9eee-2396e36c6006" />
          </div>
        </div>

        <div class=" intro-sub-head mt-12 mb-5  text-center">
          <h3 class="common-head">
            Team Challenge: I learn, I wish, I wonder
          </h3>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%206-min.png?alt=media&token=cab834df-79f1-4b5b-8c22-b48ecc14cff8" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F1.jpg?alt=media&token=a188e715-88da-4cfe-b1f1-9de5fd6165cb" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%205-min.png?alt=media&token=5ad12f1c-bc72-43d0-b17b-4a19d54ae62c" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F2.jpg?alt=media&token=84e4b0af-6c0b-48de-b3ce-6477b46bc981" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%203-min.png?alt=media&token=8ba5e0f1-81bb-4163-949d-1003cd3e0330" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F3.jpg?alt=media&token=93514be0-1021-4fe4-b8aa-94f44d32eab5" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FSaturday-Group%201-min.png?alt=media&token=50236d3c-2d7f-497a-9b00-a2228ef7c980" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F4.jpg?alt=media&token=16de96e4-14ab-427d-938f-dd21765735c1" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FSaturday-Group%202-min.png?alt=media&token=7356df11-dcd2-4700-987d-e53f33bbf318" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F5.jpg?alt=media&token=ad967eda-1dc8-4c2a-9e92-6613601c6642" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F2D%20-%20Youth%20Ambassador%20-%20Group%20Challenge%201.png?alt=media&token=04530007-9d40-429a-84b8-b726b3e520ef" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F6.jpg?alt=media&token=a5d6b873-ed23-4cf8-87bb-b5d790872aa2" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F2E%20-%20Youth%20Ambassador%20-%20Group%20Challenge%201.png?alt=media&token=b51d816d-610f-4299-9856-462fe46b4640" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F7.jpg?alt=media&token=4ea244ea-2821-4c98-80fb-fbfdbec2a9d1" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%201-min.png?alt=media&token=33d365f1-1112-4681-8220-19fd7bd01751" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F8.jpg?alt=media&token=35e81e99-2830-4b84-8358-ca2bb4eb8304" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%202-min.png?alt=media&token=060f411b-e0a4-4c7b-a784-ea2b57effb90" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F9.jpg?alt=media&token=07df3387-b1de-4bd5-9d4e-4141315c3e3e" /></a>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="video-banner1 position-relative  mt-8" >
            <a href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FWed-Group%204-min.png?alt=media&token=59c61543-b6a6-4267-8fa9-992e097f7609" target="_blank" class="d-inline-block"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2F10.jpg?alt=media&token=8ddb4f86-6d95-4d86-90a2-7ef428aec569" /></a>
          </div>
        </div>


    </div>
    <div class="hear-from-youth py-16 mt-5">
      <h3 class="common-head text-center">Lets Hear From Our Youths</h3>
      <div class="container">
        <div class="inner-page-wrap mt-5">
          <carousel
            :autoplay="false"
            :loop="true"
            :items="5"
            :dots="false"
            :margin="30"
            :nav="true"
            :responsive="{
              0: { items: 1, nav: true },
              768: { items: 3, nav: true },
              1025: { items: 4, nav: true },
              1200: { items: 5, nav: true },
            }"
          >
            <div
              v-for="videoThumb in YouthEvent"
              :key="videoThumb.videoId"
              class="single-youth-video"
            >
              <img :src="videoThumb.ThumbImg" />
              <div class="play-btn" @click="OpenYouthVideo(videoThumb)">
                <img src="../assets/Images/landing/play.svg" />
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </div>
    <div>
      <PublicFooter></PublicFooter>
    </div>



    <v-dialog
      v-model="hearYouth"
      width="560px"
      content-class="reg-options-whole position-relative"
      @click:outside="closeDialog"
    >
      <v-card>
        <v-btn class="goto-option-close" icon @click="closeDialog"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <div class="youth-video-wrap">
            <iframe
              height="100%"
              width="100%"
              allow="autoplay"
              :src="videoUrl"
              allowfullscreen="true"
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
// import jQuery from "jquery";
// let $ = jQuery;
// import { bus } from "@/main";
// import APIs from "@/components/APIInit";
// import db from "../components/firebaseInit";
// import axios from "axios";
   import carousel from "vue-owl-carousel";
// import Countdown from "vuejs-countdown";
// import moment from "moment-timezone";
// import RegOptions from "@/components/RegOptions.vue";
import PublicFooter from "@/components/PublicFooter.vue";
// import router from "@/router";
var self;
export default {
  name: "YouthAmbassadors",
  components: {
    carousel,
    PublicFooter
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (Asia-Pacific) 2022",
      meta: [
        { property: "og:type", content: "website" },
        { name: "description", content: "ASIA-PACIFIC 2022" },
        {
          property: "og:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "YOUth Matters: Celebrating Skills For the Future – Featuring the World Youth Skills Day Asia-Pacific",
        },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  data() {
    return {
       YouthEvent: [
        //  {
        //    videoId: 1,
        //    ThumbImg:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb1.jpg?alt=media",
        //    VideoFile:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F1.WYSD-Homepage%20Video.mp4?alt=media",
        //  },
        //  {
        //    videoId: 2,
        //    ThumbImg:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb2.jpg?alt=media",
        //    VideoFile:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F2.WYSD-Homepage%20Video.mp4?alt=media",
        //  },
        //  {
        //    videoId: 3,
        //    ThumbImg:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb3.jpg?alt=media",
        //    VideoFile:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F3.WYSD-Homepage%20Video.mp4?alt=media",
        //  },
        //  {
        //    videoId: 4,
        //    ThumbImg:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb4.jpg?alt=media",
        //    VideoFile:
        //    "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F4.WYSD-HomepageVideo.mp4?alt=media",
        //  },
        //  {
        //    videoId: 5,
        //    ThumbImg:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2Fthumb5.jpg?alt=media",
        //    VideoFile:
        //      "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FVideos%2F5.WYSD-HomepageVideo.mp4?alt=media",
        //  },
         {
           videoId: 1,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGroup4_Yuki%20Uemura.png?alt=media&token=131c7e1a-999a-4fc4-b801-168694499e0c",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661517736934_Group4_Yuki%20Uemura.mp4?alt=media&token=0df174ac-e8c2-4d48-8b44-af3e7a36bbfa",
         },
         {
           videoId: 2,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp1_Edward%20Mak.png?alt=media&token=6f95e0c2-5af5-4f9d-8fbd-c5821e7a17f7",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661517890254_Grp1_Edward%20Mak.mp4?alt=media&token=69ffdfa4-f5d1-485f-a7f1-4958320705a9",
         },
         {
           videoId: 3,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp5_Kyaw%20Zin%20Thu.png?alt=media&token=668a114c-d4e1-4e34-88b5-98c36324c28d",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661517996431_Grp5_Kyaw%20Zin%20Thu.mp4?alt=media&token=e03df93e-8a67-4ae4-8a5a-800f90ef9aa5",
         },
         {
           videoId: 4,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp5_YeHtetLin(Brian).png?alt=media&token=35cfd4b9-44de-4008-9d31-beeeae0e7458",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518066902_Grp5_YeHtetLin(Brian).mp4?alt=media&token=23d6c888-811d-4527-97f2-bf3f785ff506",
         },
         {
           videoId: 5,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FTran%20Ba%20Thao%20Uyen_GR6.png?alt=media&token=92f6bba2-93b5-4ac7-a850-c81013735d27",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518142767_Tran%20Ba%20Thao%20Uyen_GR6.mp4?alt=media&token=b2f4a0e4-c618-4627-b757-1fa7985eb132",
         },
         {
           videoId: 6,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FVu%20Thu%20Thao-Gr6.png?alt=media&token=785d47da-6fdc-4712-9b67-c84a92a14c2d",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518182095_Vu%20Thu%20Thao-Gr6.mp4?alt=media&token=5b338f96-ee45-4313-859f-fbffa6b30e6f",
         },
         {
           videoId: 7,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FXie%20Haoliang-Shenzhen%20Polytechnic-China.png?alt=media&token=9ececf64-048e-4763-be7f-bd180645a245",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518207223_Xie%20Haoliang-Shenzhen%20Polytechnic-China.mp4?alt=media&token=096cd08e-bc74-4d7f-a3d9-3f76862bd92d",
         },
         {
           videoId: 8,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp3_Alicia.png?alt=media&token=d741a153-2771-49c8-bdc9-603fa176875d",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518746768_Untitled.mp4?alt=media&token=7f796c42-079e-4615-be40-05855f712df6",
         },
         {
           videoId: 9,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSkylar-%20UNESCO-UNEVOC%20Youth%20Voices%20campaign.png?alt=media&token=97c4f424-33db-47ad-a2ec-65fe861775af",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518791864_Skylar-%20UNESCO-UNEVOC%20Youth%20Voices%20campaign%20.mp4?alt=media&token=b626d904-f7df-43e4-89a2-428a9a83f172",
         },
         {
           videoId: 10,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FIMG.png?alt=media&token=f0b97283-c95e-487d-a61d-1eac3a261fe1",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518874856_IMG_5743.mp4?alt=media&token=109ab3a4-2b0c-423d-9646-7932a4c8c5fb",
         },
         {
           videoId: 11,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp3-Chen%20Zhiruo.png?alt=media&token=0fbd75be-82cc-403e-9dbc-40bd0b32230e",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661518963968_Grp3-Chen%20Zhiruo.mp4?alt=media&token=3a58ac0b-1cf8-4b2e-91c1-8ba6c8a2528e",
         },
         {
           videoId: 12,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp3_Derica%20Kon%20Yi%20Ru.png?alt=media&token=b7654af2-e04e-4976-bed3-7c75fa1b97fd",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519012944_Grp3_Derica%20Kon%20Yi%20Ru.mp4?alt=media&token=30ff929a-e111-40aa-b2ea-70fb46bc6688",
         },
         {
           videoId: 13,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp2_Hiroyuki.png?alt=media&token=b94a11b8-24d5-4e88-b027-5419943463bd",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519102649_Grp2_Hiroyuki.mp4?alt=media&token=c9562375-4a91-483b-915d-49f5556eb27d",
         },
         {
           videoId: 14,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGroup%204%20Muhammad%20Haris.png?alt=media&token=90a40547-2eb9-4997-a336-39bb40c57392",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519195048_Untitled%20(1).mp4?alt=media&token=d30d4fe4-9aad-45d6-991c-41f6e47bf75a",
         },
         {
           videoId: 15,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp4_Chew%20Fong%20Lam.png?alt=media&token=5d8f3fb7-4930-4203-9758-745de1595d03",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519530729_Untitled%20(2).mp4?alt=media&token=d6d6f933-271a-4a8e-9834-95e64868a000",
         },
         {
           videoId: 16,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FGrp2_Edison%20Chan.png?alt=media&token=cda18b54-e3d9-45b1-8cd3-be251bc9d479",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519598465_Untitled%20(3).mp4?alt=media&token=01852a14-e89a-4635-a85f-567e290b4071",
         },
         {
           videoId: 17,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FPang%20Weixun.png?alt=media&token=7364f122-f1fd-4e52-a900-0c2132cbdcdd",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661519710970_Untitled%20(4).mp4?alt=media&token=458957d1-9eac-427b-bde2-5feff71aed67",
         },
         {
           videoId: 18,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FApisada-Rangsit%20University-Thailand.png?alt=media&token=a1b75bba-f9db-413c-af27-1fee2cd2db46",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661520643565_Apisada-Rangsit%20University-Thailand.mp4?alt=media&token=bdcb07b5-806a-4ddf-8cee-e7e8969be013",
         },
         {
           videoId: 19,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FINA%20-%20Fydia%20-%20BINUS%20University.png?alt=media&token=e2acf3cf-bcc5-4711-b4fc-5fe5ce2ccea7",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661520684155_INA%20-%20Fydia%20-%20BINUS%20University.mp4?alt=media&token=563c9cc7-11a2-4dc6-8dd9-edca72dc9390",
         },
         {
           videoId: 20,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FJapan-Yu-KNCT%20WYSD%20youth%20voices%20videos.png?alt=media&token=012669ef-bb25-409f-bfa9-bf3ebb84dde1",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661520906346_Japan-Yu-KNCT%20WYSD%20youth%20voices%20videos.mp4?alt=media&token=482c4b82-6337-4b17-902e-5f36b91451b6",
         },
         {
           videoId: 21,
           ThumbImg:
             "",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661521018875_Myanmar%20(GTI)_Mi%20Moe%20Yoon%20May%20%20.mp4?alt=media&token=6f6356d7-c758-48dc-bdc0-a8864df5ad6e",
         },
         {
           videoId: 22,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FNatcha%20Visavakul-Rangsit%20University-Thailand.png?alt=media&token=98f58b90-0b96-409f-8a71-f360c4c04df8",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661523603593_Natcha%20Visavakul-Rangsit%20University-Thailand.mp4?alt=media&token=2a372c1c-6142-4309-ac0c-a65ee2717d74",
         },
         {
           videoId: 23,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSG-Alpha%20Ho-NUS%201%20min%20video.png?alt=media&token=7b71c4ce-de9a-4647-9d93-b5d6a355f024",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661523674913_SG-Alpha%20Ho-NUS%201%20min%20video.mp4?alt=media&token=858e9217-2907-4d26-a59f-550a0112c6cb",
         },
         {
           videoId: 24,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSG-CHUA%20CHOON%20HSIANG-NYP%20(Let%20me%20know%20if%20there%20is%20a%20issue).png?alt=media&token=b1c8864f-aae8-401a-9868-4d608962f925",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661523739658_SG-CHUA%20CHOON%20HSIANG-NYP%20(Let%20me%20know%20if%20there%20is%20a%20issue).mp4?alt=media&token=8e54162a-efde-46c3-a142-82ecf5257c1a",
         },
         {
           videoId: 25,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSIN_Hannah%20Emilia_Temasek%20Poly.png?alt=media&token=57a868d0-9e90-4bdd-8a55-a7b6f760093b",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661523833768_SIN_Hannah%20Emilia_Temasek%20Poly.mp4?alt=media&token=b42e6b70-130d-4f6e-9bd7-c1c6bb098a8d",
         },
         {
           videoId: 26,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSIN-Devin-NYP%20WYSD.png?alt=media&token=4d6ee887-bb62-44cb-83b0-d929644423fa",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661523929240_SIN-Devin-NYP%20WYSD.mp4?alt=media&token=70befd95-9b8a-4907-884c-ec4eb59dcb12",
         },
         {
           videoId: 27,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSIN-LINA%20FARHANAH-TEMASEK%20POLYTECHNIC.png?alt=media&token=9efbcab3-85a1-4c15-acb7-7e77e9b1415c",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661524167729_SIN-LINA%20FARHANAH-TEMASEK%20POLYTECHNIC.MOV.mp4?alt=media&token=39b89c4a-4f0d-4bcf-8314-95c42c9249ff",
         },
         {
           videoId: 28,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSIN-Stephen%20Goh%20WYSD.png?alt=media&token=4014b992-9d08-488b-b99a-7c9dafa4345a",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661524205298_SIN-Stephen%20Goh%20WYSD.mp4?alt=media&token=a70592ee-6e03-41b8-9b9c-b38a751b3a95",
         },
          {
           videoId: 29,
           ThumbImg:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FSIN-ZACHARY(WYSD)-Temasek%20Polytechnic.png?alt=media&token=596fc5af-47cd-4210-a403-0cd7edffa653",
           VideoFile:
             "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661524253201_SIN-ZACHARY(WYSD)-Temasek%20Polytechnic.mp4?alt=media&token=9136d94c-01b6-470c-ab44-913530fd899a",
         },
          {
            videoId: 30,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FUNESCO-UNEVOC%20Youth%20Voices%20Videos.png?alt=media&token=c1b2413d-8294-478d-8f6d-a92444860134",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661524562809_UNESCO-UNEVOC%20Youth%20Voices%20Videos.mp4?alt=media&token=bf06f43a-6683-4863-81cc-11d0a3ea8720",
          },
          {
            videoId: 31,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FVN-Thinh%20Nguyen-Duy%20Tan%20University.png?alt=media&token=283febcf-3e0c-4a4c-9c07-982bebe993b6",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661524923362_VN-Thinh%20Nguyen-Duy%20Tan%20University%20(1).mp4?alt=media&token=151a2e50-aa52-4935-bfc1-3dbbbffcadae",
          },
          {
            videoId: 32,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FWYSD%20UNESCO%20TVET%20Youth%20Voices_Republic%20Polytechnic_Wong%20Jia%20Xin%20Brigitte.png?alt=media&token=240943a6-8b79-4788-a7bb-b80057ea188b",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661525161347_Untitled%20(6).mp4?alt=media&token=45389275-11e1-4d5d-9e13-2afa596e1112",
          },
          {
            videoId: 33,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FWYSD_AJINKYA_SSBT.png?alt=media&token=2ac83cab-14b4-4df2-ab92-f86b122fdab3",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661525337755_WYSD_AJINKYA_SSBT.mp4?alt=media&token=aeee4171-7a03-4600-8823-e5a8c7f258d7",
          },
          {
            videoId: 34,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FWYSD_Nikita-SSBT_s%20COET%2C%20India.png?alt=media&token=ce1e1460-d62e-4892-9e3d-19a364966175",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661525552707_Untitled%20(7).mp4?alt=media&token=02290192-475c-4cd3-99c0-7b0c3bbedd2b",
          },
          {
            videoId: 35,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FWYSD_Ojas%20Patil_SSBT%20COET_INDIA%20(2).png?alt=media&token=b536c580-b4ac-4a61-9490-399a1a02d9e8",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661525739475_Untitled%20(8).mp4?alt=media&token=c37d4d49-e1a1-4d56-b653-b0efc7f15acf",
          },
          {
            videoId: 36,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FWYSD_Tiffani%20Tirta%20Chanjaya%20_Bina%20Nusantara%20University.png?alt=media&token=2a9c8b69-12b0-40fc-8630-4450e6fce4c8",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661525902475_Untitled%20(5).mp4?alt=media&token=25cbf5ac-7a36-44a3-b734-ce5482ba45e7",
          },
          {
            videoId: 37,
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FExhibitor%2FResources%2FA8ED65D3-CFBE-47E6-B738-0454BA0B2155%20(1).png?alt=media&token=0849eac8-1a94-46bd-99bf-3e1889ac77b5",
            VideoFile:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1649692335719%2FResources%2Fvideo%2F1661526172564_A8ED65D3-CFBE-47E6-B738-0454BA0B2155%20(1).mp4?alt=media&token=68f02981-017c-4e99-a08e-3bc60efb53b4",
          },
       ],
       hearYouth: false,
    };
  },
  computed: {
  },
  created() {
    self = this;
    self.currentDomain = location.origin;
    self.clientId = self.getClientId();
    self.publicEventCollection = self.getPublicEventCollection();
    self.event_collectionName = self.getEventCollectionName();
  },
  mounted() {
  },
  updated() {
  },
  methods: {
     OpenYouthVideo(data) {
       console.log("data-", data);
       self.videoUrl = data.VideoFile;
       self.hearYouth = true;
     },
     closeDialog() {
       self.videoUrl = null;
       self.hearYouth = false;
     },
  },
};
</script>
<style>
.video-banner1{
  box-shadow: 0 0 6px rgba(0,0,0,0.6);
  border-radius: 10px;
  overflow: hidden;
  display: inline-block;
}
.intro-sub-head h3.common-head {
    font-size: 25px !important;
}
</style>
